import React, { useEffect, useState } from 'react';
import { SWORN_DATA } from '../../gameData';

const AssetPreloader: React.FC = () => {
    const [preloaded, setPreloaded] = useState(false);

    useEffect(() => {
        const assetsToPreload: string[] = [];

        // Preload UI Backgrounds
        if (SWORN_DATA.ui_assets?.backgrounds) {
            Object.values(SWORN_DATA.ui_assets.backgrounds).forEach(url => {
                if (url) assetsToPreload.push(url);
            });
        }

        // Preload Knight Portraits (Framed & Unframed currently handled by iconPath, but let's grab base ones)
        // This is a simplification; a full crawl might be too heavy. 
        // We focus on the background UI which causes the biggest "flash".
        
        // Preload Tutorial Assets
        if (SWORN_DATA.ui_assets?.tutorial) {
            Object.values(SWORN_DATA.ui_assets.tutorial).forEach(url => {
                if (url) assetsToPreload.push(url);
            });
        }
        // Preload Panel Icons
        if (SWORN_DATA.ui_assets?.panels) {
            Object.values(SWORN_DATA.ui_assets.panels).forEach(url => {
                if (url) assetsToPreload.push(url);
            });
        }
        
        // nimue
        if (SWORN_DATA.ui_assets?.nimue) {
           const n = SWORN_DATA.ui_assets.nimue;
           if (n.mod_frame_on) assetsToPreload.push(n.mod_frame_on);
           if (n.mod_frame_off) assetsToPreload.push(n.mod_frame_off);
           if (n.text_bg) assetsToPreload.push(n.text_bg);
        }

        // Create browser cache entries via Image object
        const promises = assetsToPreload.map(src => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;
                img.onload = resolve;
                img.onerror = resolve; // Continue even if one fails
            });
        });

        Promise.all(promises).then(() => setPreloaded(true));

    }, []);

    // We don't render anything visible
    return null; 
};

export default AssetPreloader;
